module.exports = __webpack_public_path__ + "static/media/small.d8109510.png";